import { withLayout } from '../../layout';

import BrandPage from './sites.page';

export default withLayout(BrandPage);
